/**
 * @mixin
 */
module.exports = {
  props: {
    /** 编辑、新增弹框表单 */
    dialogForm: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 编辑、新增弹框表单校验 */
    dialogRules: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
